const defaultHeaders = new Headers();

const fetchOptions = (method = "GET", body = null) => {
  const options = {
    method,
    headers: defaultHeaders,
    credentials: "include",
    redirect: "follow",
  };
  if (body) {
    options.body = body;
  }
  return options;
};

export const getEmpresas = async (baseUrl) => {
  const response = await fetch(`${baseUrl}getAllEmpresas`, fetchOptions());
  if (!response.ok) throw new Error("Error al obtener las empresas");
  const data = await response.json();
  if (Array.isArray(data.empresas)) return data.empresas;
  throw new Error("Formato de respuesta inesperado");
};

export const getTiposSubproducto = async (baseUrl, idEmpresa) => {
  const response = await fetch(
    `${baseUrl}getSubproductosByIdEmpresa?idEmpresa=${idEmpresa}`,
    fetchOptions()
  );
  if (!response.ok) throw new Error("Error al obtener los tipos de subproducto");
  const data = await response.json();
  if (Array.isArray(data.subproductos)) return data.subproductos;
  throw new Error("Formato de respuesta inesperado");
};

export const getSubproductosEntidad = async (baseUrl, idEmpresa) => {
  const query = idEmpresa != null ? `?idEmpresa=${idEmpresa}` : "";
  const response = await fetch(
    `${baseUrl}getSubproductosEntidad${query}`,
    fetchOptions()
  );
  if (!response.ok) {
    let detalle = `Error al obtener los subproductos (${response.status})`;
    try {
      const err = await response.json();
      if (err && err.detalle) {
        detalle = err.detalle;
      }
    } catch (e) {
      // La respuesta de error no es JSON
    }
    throw new Error(detalle);
  }
  const data = await response.json();
  if (Array.isArray(data.subproductos)) return data.subproductos;
  throw new Error("Formato de respuesta inesperado");
};

export const getSubproductosBloqueados = async (baseUrl, idProducto) => {
  if (idProducto == null) return [];
  const response = await fetch(
    `${baseUrl}getSubproductosBloqueados?idProducto=${idProducto}`,
    fetchOptions()
  );
  if (!response.ok) {
    let detalle = `Error al obtener los subproductos bloqueados (${response.status})`;
    try {
      const err = await response.json();
      if (err && err.detalle) {
        detalle = err.detalle;
      }
    } catch (e) {
      // La respuesta de error no es JSON
    }
    throw new Error(detalle);
  }
  const data = await response.json();
  if (Array.isArray(data.ids_subproductos)) return data.ids_subproductos;
  throw new Error("Formato de respuesta inesperado");
};

export const guardarSubproductoCompleto = async (baseUrl, payload) => {
  const response = await fetch(`${baseUrl}guardarSubproductoCompleto`, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error((data && data.mensaje) || "Error al guardar el subproducto");
  }
  return data;
};

export const cambiarEstadoSubproducto = async (baseUrl, id, activo) => {
  const response = await fetch(
    `${baseUrl}cambiarEstadoSubproducto?id=${id}&activo=${activo}`,
    fetchOptions("PUT")
  );
  if (!response.ok) throw new Error("Error al cambiar estado del subproducto");
  return response;
};

export const getReporteSubproductos = async (baseUrl) => {
  const response = await fetch(`${baseUrl}reporteSubproductos`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    let detalle = `Error al exportar reporte de subproductos (${response.status})`;
    try {
      const err = await response.json();
      if (err && err.detalle) {
        detalle = err.detalle;
      }
    } catch (e) {
      // La respuesta de error no es JSON
    }
    throw new Error(detalle);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "reporte_subproductos.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getSubproductoFicha = async (baseUrl, idSubproducto) => {
  const response = await fetch(
    `${baseUrl}getSubproductoFicha?idSubproducto=${idSubproducto}`,
    fetchOptions()
  );
  if (!response.ok) throw new Error("Error al obtener la ficha del subproducto");
  return response.json();
};
